import * as React from 'react';
export var LinkedinCircle = function LinkedinCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
    x: "13.8",
    y: "20.5",
    fill: "#969696",
    width: "4.4",
    height: "13.9"
  }), React.createElement("path", {
    fill: "#969696",
    d: "M30.1,20.4c-2.5,0-4.1,1.4-4.4,2.3v-2.2h-4.9c0.1,1.2,0,13.9,0,13.9h4.9v-7.5c0-0.4,0-0.8,0.1-1.1\n        c0.3-0.8,1.1-1.7,2.4-1.7c1.7,0,2.5,1.3,2.5,3.2v7.2h5v-7.7C35.6,22.4,33.2,20.4,30.1,20.4z"
  }), React.createElement("path", {
    fill: "#969696",
    d: "M15.9,14c-1.6,0-2.7,1-2.7,2.4c0,1.3,1,2.4,2.6,2.4h0c1.6,0,2.7-1.1,2.7-2.4C18.5,15,17.5,14,15.9,14z"
  })), React.createElement("path", {
    fill: "#969696",
    d: "M24,48C10.8,48,0,37.2,0,24S10.8,0,24,0s24,10.8,24,24S37.2,48,24,48z M24,1.8C11.8,1.8,1.8,11.8,1.8,24\n      S11.8,46.2,24,46.2S46.2,36.2,46.2,24S36.2,1.8,24,1.8z"
  })));
};